
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoAvDaysGrid extends Serenity.EntityGrid<PsPromoAvDaysRow, any> {
        protected getColumnsKey() { return PsPromoAvDaysColumns.columnsKey; }
        protected getDialogType() { return PsPromoAvDaysDialog; }
        protected getIdProperty() { return PsPromoAvDaysRow.idProperty; }
        protected getInsertPermission() { return PsPromoAvDaysRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoAvDaysRow.localTextPrefix; }
        protected getService() { return PsPromoAvDaysService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}